/**
 * The wine lookup lists as a member sees them: typeahead search, and "Not in
 * the list? Add it" (W5's public endpoints — the admin Setup page has its own
 * client in `lookupAdmin.ts`).
 */
import type {
  LookupCreateInput,
  LookupCreateResult,
  LookupOption,
  WineLookupKind,
  WineWorld,
} from '@gwc/shared';
import { api } from '../lib/api';

export interface LookupSearchParams {
  q?: string;
  world?: WineWorld;
  regionId?: string;
  limit?: number;
}

export const lookupsApi = {
  search: (kind: WineLookupKind, params: LookupSearchParams = {}) => {
    const qs = new URLSearchParams();
    if (params.q) qs.set('q', params.q);
    if (params.world) qs.set('world', params.world);
    if (params.regionId) qs.set('regionId', params.regionId);
    if (params.limit) qs.set('limit', String(params.limit));
    const tail = qs.toString();
    return api
      .get<{ data: LookupOption[] }>(`/lookups/${kind}${tail ? `?${tail}` : ''}`)
      .then((r) => r.data);
  },
  /** Idempotent by name: adding one that exists returns it (`created: false`). */
  create: (kind: WineLookupKind, body: LookupCreateInput) =>
    api.post<LookupCreateResult>(`/lookups/${kind}`, body),
};
